import { FC } from 'react';
import ProStatistic, { StatisticProps } from './statistic';
import ProStatisticCountdown, { CountdownProps } from './countdown';

export type IStatisticComponent = FC<StatisticProps> & {
  Countdown: FC<CountdownProps>;
};

const TransStatistic = ProStatistic as IStatisticComponent;
TransStatistic.Countdown = ProStatisticCountdown;

export default TransStatistic;
